import React from "react";
import { Link } from "react-router-dom";
import HubHomeBannerCarousel from "../hub/HubHomeBannerCarousel";

export default function MarketplaceAdSection({
  banners = [],
  ariaLabel = "Marketplace advertising banners",
  hideFallback = false,
}) {
  const items = Array.isArray(banners) ? banners.filter(Boolean) : [];
  const imageBanners = items.filter((banner) => String(banner.image || "").trim());
  const textBanners = items.filter(
    (banner) => !String(banner.image || "").trim() && (banner.title || banner.description || banner.redirect_url),
  );

  if (imageBanners.length) {
    return (
      <div className="explore-categories-ad">
        <HubHomeBannerCarousel
          banners={imageBanners}
          className="hub-banner-carousel--marketplace"
          ariaLabel={ariaLabel}
          hideBlurredBackground
          autoHeight
        />
      </div>
    );
  }

  if (textBanners.length) {
    const banner = textBanners[0];
    const title = String(banner.title || "Reach 50,000+ B2B Decision Makers").trim();
    const description = String(
      banner.description || "Promote your brand across categories, auctions, and procurement workflows.",
    ).trim();
    const redirectUrl = String(banner.redirect_url || "/contact?enquiry=advertising").trim();
    const ctaLabel = "Start Advertising";

    return (
      <section className="explore-categories-cta">
        <div className="explore-categories-cta__inner">
          <div>
            <h2>{title}</h2>
            {description ? <p>{description}</p> : null}
          </div>
          {redirectUrl.startsWith("/") ? (
            <Link to={redirectUrl} className="explore-categories-cta__btn">
              {ctaLabel}
            </Link>
          ) : (
            <a href={redirectUrl} className="explore-categories-cta__btn" target="_blank" rel="noopener noreferrer">
              {ctaLabel}
            </a>
          )}
        </div>
      </section>
    );
  }

  if (hideFallback) return null;

  return (
    <section className="explore-categories-cta">
      <div className="explore-categories-cta__inner">
        <div>
          <h2>Reach 50,000+ B2B Decision Makers</h2>
          <p>Promote your brand across categories, auctions, and procurement workflows.</p>
        </div>
        <Link to="/contact?enquiry=advertising" className="explore-categories-cta__btn">
          Start Advertising
        </Link>
      </div>
    </section>
  );
}
